<template>
  <!-- 新建工单 -->
  <div class="rzy-page">
    <div class="rzy-top-bar">
      <el-button
        type="primary"
        @click="creatWuLiao"
        style=""
        icon="el-icon-circle-plus"
        >提交</el-button
      >
    </div>

    <div class="form-wrap">
      <el-card>
        <el-form
          :model="wuLiaoInfo"
          :rules="wuLiaoRelues"
          ref="wuLiaoFormRef"
          inline
          size="mini"
        >
          <el-row>
            <!-- 第1行 -->
            <el-col :span="24">
              <el-form-item label="物料编号" prop="XXXXXXXX">
                <el-input
                  v-model="wuLiaoInfo.number"
                  disabled="isDisabled"
                  placeholder="自动生成"
                >
                </el-input>
              </el-form-item>

              <el-form-item label="物料名称" prop="name">
                <el-input v-model="wuLiaoInfo.name" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item label="单位">
                <el-select v-model="wuLiaoInfo.unit" placeholder="请选择">
                  <el-option
                    v-for="item in option_unit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="启用">
                <el-radio-group v-model="wuLiaoInfo.active">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <!-- 第2行 -->
            <el-col :span="24">
              <el-form-item label="物料类型">
                <el-select
                  v-model="wuLiaoInfo.kind_change"
                  placeholder="请选择"
                  disabled="isDisabled"
                >
                  <el-option
                    v-for="item in option_kind"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="物料分组">
                <el-select
                  v-model="wuLiaoInfo.group_change"
                  placeholder="请选择"
                  disabled="isDisabled"
                >
                  <el-option
                    v-for="item in option_group"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="物料规格">
                <el-select v-model="wuLiaoInfo.spec" placeholder="请选择">
                  <el-option
                    v-for="item in option_spec"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 第3行 -->
            <el-col :span="24">
              <el-form-item label="牵拉系数" prop="stretchRate_change">
                <el-input
                  v-model="wuLiaoInfo.stretchRate_change"
                  placeholder="请输入"
                >
                </el-input>
              </el-form-item>

              <el-form-item label="D数" prop="dcount_change">
                <el-input
                  v-model="wuLiaoInfo.dcount_change"
                  placeholder="请输入"
                >
                </el-input>
              </el-form-item>

              <el-form-item label="支数" prop="zcount_change">
                <el-input
                  v-model="wuLiaoInfo.zcount_change"
                  placeholder="请输入"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <!-- 第4行 -->
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input
                  v-model="wuLiaoInfo.remark"
                  placeholder="请输入"
                  style="width: 800px;"
                  type="textarea"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>

    <el-row :gutter="10" style="margin-top:10px">
      <el-col :lg="12" :md="24" :sm="24">
        <div class="form-wrap mini auto-width">
          <div class="toolbar">
            <div class="col-header">物料规格</div>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-circle-plus"
              @click="wuLiaoGuiGe_addLine()"
            >
              增行
            </el-button>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-remove"
              @click="wuLiaoGuiGe_delLine()"
              >删行
            </el-button>
          </div>
          <el-table
            :data="wuLiaoGuiGe"
            class="craft-order"
            :row-style="{ height: '0' }"
            :header-cell-style="{ padding: 0 }"
            border
          >
            <el-table-column
              fixed
              label="行"
              width="50px"
              prop="lineNo"
              align="center"
            />

            <!-- hcy: 问了liuqy, 不需要这个字段。 
                            <el-table-column label="通用规格" width="250" align="center">
                                <template slot-scope="data">
                                    <input v-model="data.row.XXXX" class="table-input" />
                                </template>
                            </el-table-column> 
        -->

            <el-table-column label="规格名称" width="180" align="center">
              <template slot-scope="data">
                <el-input v-model="data.row.specName" />
              </template>
            </el-table-column>

            <!-- hcy: 货号  应该是  specNumber -->
            <el-table-column label="货号" width="140" align="center">
              <template slot-scope="data">
                <el-input
                  v-model="data.row.XXXX"
                  placeholder="自动生成"
                  disabled="isDisabled"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column label="默认" width="100" align="center">
              <template slot-scope="data">
                <el-select
                  v-model="data.row.isDefault"
                  placeholder=""
                  @change="selectChange($event, data.row.lineNo)"
                >
                  <el-option
                    v-for="item in option_default"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :lg="12" :md="24" :sm="24">
        <div class="form-wrap mini auto-width">
          <div class="toolbar">
            <div class="col-header">物料组成</div>
            <el-button
              disabled="isDisabled"
              type="primary"
              size="mini"
              icon="el-icon-circle-plus"
              @click="$refs.materialSelect.show()"
              >增行
            </el-button>
            <el-button
              disabled="isDisabled"
              type="primary"
              size="mini"
              icon="el-icon-remove"
              @click="wuLiaoZuCheng_delLine()"
              >删行
            </el-button>
          </div>

          <el-table
            :data="wuLiaoZuCheng"
            class="craft-order"
            :row-style="{ height: '0' }"
            :cell-style="{ padding: '0px' }"
            :header-cell-style="{ padding: 0 }"
            border
          >
            <el-table-column
              fixed
              label="行"
              width="50px"
              prop="lineNo"
              align="center"
            />

            <el-table-column label="物料编码" width="140" align="center">
              <template slot-scope="data">
                <el-input v-model="data.row.number" disabled="isDisabled" />
              </template>
            </el-table-column>

            <el-table-column label="物料名称" width="120" align="center">
              <template slot-scope="data">
                <el-input v-model="data.row.name" disabled="isDisabled" />
              </template>
            </el-table-column>

            <el-table-column label="规格编码" width="140" align="center">
              <template slot-scope="data">
                <el-input v-model="data.row.specNumber" disabled="isDisabled" />
              </template>
            </el-table-column>

            <el-table-column label="规格名称" width="120" align="center">
              <template slot-scope="data">
                <el-input v-model="data.row.specName" disabled="isDisabled" />
              </template>
            </el-table-column>

            <el-table-column label="占比(%)" width="60" align="center">
              <template slot-scope="data">
                <el-input v-model="data.row.percent" />
              </template>
            </el-table-column>

            <el-table-column label="备注" width="150" align="center">
              <template slot-scope="data">
                <el-input v-model="data.row.remark" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    // 非负浮点数 检测
    var floatCheck = (rules, value, cb) => {
      const ruler = /^\d+(\.\d+)?$/;
      if (ruler.test(value)) {
        return cb();
      }
      cb(new Error("请输入非负浮点数"));
    };
    var floatyl = (rules, value, cb) => {
      const ruler = /^[^\s]*$/;;
      if (ruler.test(value)) {
        return cb();
      }
      cb(new Error("物料名称不能输入空格"));
    };

    return {
      // 物料规格
      wuLiaoGuiGe_index: 0,
      wuLiaoGuiGe: [], //用户输入的
      wuLiaoGuiGeTemp: null, //删除的临时记录。
      wuLiaoGuiGeDelList: [], //删除列表

      wuLiaoGuiGeKeys: {
        lineNo: {
          value: "行",
          width: 50,
        },
        specName: {
          value: "规格名称",
          width: 250,
        },
        specNumber: {
          value: "货号",
          width: 250,
        },
        isDefault: {
          value: "默认",
          width: 250,
        },
      },

      wuLiaoInfo: {
        group_change: "原料", //分组
        name: "", // 物料名称
        number: "", // 物料编号
        spec: "通用规格", //规格
        kind_change: "原料", //物料类型
        unit: "千克", //单位
        active: 1, //lable前有冒号使用数字

        stretchRate_change: Math.round(0).toFixed(2), //牵拉系数
        // dcount_change: Math.round(0).toFixed(2), //D数
        dcount_change: "", //D数 （必填项）
        zcount_change: Math.round(0).toFixed(2), //支数

        remark: "", //备注
      },

      // 调试用 下拉选择框--sta
      optionForDebug: [
        {
          label: "调试选项1",
          value: "1",
        },
        {
          label: "调试选项2",
          value: "2",
        },
      ],
      // 调试用 下拉选择框--end

      option_kind: [
        {
          label: "原料",
          value: "1",
        },
      ],
      option_group: [
        {
          label: "原料",
          value: "1",
        },
      ],

      option_spec: [
        {
          label: "通用规格",
          value: "1",
        },
      ],
      option_source: [
        {
          label: "自制",
          value: "1",
        },
      ],

      option_unit: [
        {
          label: "米",
          value: "米",
        },
        {
          label: "千克",
          value: "千克",
        },
      ],

      //物料规格-默认
      option_default: [
        {
          label: "是",
          value: "true",
        },
        {
          label: " ",
          value: "false",
        },
      ],

      wuLiaoRelues: {
        name: [
          {
            required: true,
            message: "请输入物料名称",
            trigger: "blur",
          },
          {
            validator: floatyl,
            trigger: "blur",
          },
        ],
        
        dcount_change: [
          {
            required: true,
            message: "请输入D数(小数2位)",
            trigger: "blur",
          },
          {
            validator: floatyl,
            trigger: "blur",
          },
        ],
        
      },

      //物料规格--默认
    };
  },
  methods: {
    // 外部调用，验证必填的输入框是否都有填写
    getValid() {
      this.$refs.wuLiaoFormRef.validate((valid) => {
        this.valid = valid;
      });
      return this.valid;
    },

    //创建 胚布
    creatWuLiao() {
      // 判定数据  是否都填好了
      if (!this.getValid()) {
        return;
      }

      var wuLiaoOrder = {
        // createTime: 0  后台创建
        factoryId: 0,
        group: "YL", //物料分组 --先写死
        kind: "YL", //物料类型 --先写死
        name: this.wuLiaoInfo.name, //物料名称
        // number: this.wuLiaoInfo.number, //物料编号--后台创建

        //物料组成记录
        partItems: [],
        spec: this.wuLiaoInfo.spec, //规格
        //物料规格
        specItems: [],
        unit: this.wuLiaoInfo.unit, //单位
        useBatch: this.wuLiaoInfo.active === 1 ? true : false, //启用批号

        //后台 用integer存储，放大100倍。
        stretchRate:
          Number(this.hmjDataChange(this.wuLiaoInfo.stretchRate_change)) * 100, //牵拉系数
        dcount: Number(this.hmjDataChange(this.wuLiaoInfo.dcount_change)) * 100, //D数
        zcount: Number(this.hmjDataChange(this.wuLiaoInfo.zcount_change)) * 100, //支数
      };

      //准备'物料规格'表-----------------------------------------------------
      // 删除 物料规格 中多余的空行.
      wuLiaoOrder.specItems = this.clearNullItem(this.wuLiaoGuiGe);

      //hcy: 昨天那个问题，已经更新了后台，前端这边也需要做一个修改，
      //就是要删除的物料，传递到后台需要加一个isDeleted=1。
      //比如物料组成有1,2,3,4,5条记录，如果要删除2和3条记录，
      //那么2和3也要传递到后台，至少需要指定id和isDeleted=1才会删除
      for (let i = 0; i < this.wuLiaoGuiGeDelList.length; i++) {
        let m_item = {
          id: this.wuLiaoGuiGeDelList[i].id,
          isDeleted: 1,
        };
        wuLiaoOrder.specItems.push(m_item);
      }

      //bug: 新建时 默认=是，成功后 首次编辑，后台返回404，isDefault='是'。
      for (let i = 0; i < wuLiaoOrder.specItems.length; i++) {
        if (wuLiaoOrder.specItems[i].isDefault === "是") {
          wuLiaoOrder.specItems[i].isDefault = true;
        } else if (wuLiaoOrder.specItems[i].isDefault === " ") {
          wuLiaoOrder.specItems[i].isDefault = false;
        }
      }

      switch (this.$route.query.type) {
        case 0: // 新建
          this.$requestBase(
            {
              url: "v1/material/create",
              method: "POST",
              data: wuLiaoOrder,
            },
            true
          ).then((res) => {
            this.$Message.success(res.info);
            this.$router.push("/wuliaodangan/yuanLiao");
          });
          break;

        case 1: // 编辑
          // 编辑时候，要注意把id 强制追加进去。
          wuLiaoOrder.id = this.wuLiaoInfo.id;

          this.$requestBase(
            {
              url: "v1/material/update",
              method: "POST",
              data: wuLiaoOrder,
            },
            true
          ).then((res) => {
            this.$Message.success(res.info);
            this.$router.push("/wuliaodangan/yuanLiao");
          });

          break;
        default:
          break;
      }
    },

    //物料规格--增行
    wuLiaoGuiGe_addLine() {
      // console.log('this.wuLiaoGuiGe_index = ', this.wuLiaoGuiGe_index)
      if (this.wuLiaoGuiGe_index >= 10) {
        this.$Message.closeAll(); //防止多条提示
        this.$Message.success("最多增加10行");
      } else {
        this.wuLiaoGuiGe.push({
          lineNo: this.wuLiaoGuiGe_index + 1,
        });
        this.wuLiaoGuiGe_index++;
      }
    },

    //物料规格--删行
    wuLiaoGuiGe_delLine() {
      if (this.wuLiaoGuiGe_index <= 0) {
        this.$Message.closeAll(); //防止多条提示
        this.$Message.success("无行可删");
      } else {
        this.wuLiaoGuiGe_index--;
        this.wuLiaoGuiGeTemp = this.wuLiaoGuiGe.pop();

        // console.log('this.wuLiaoGuiGeTemp=', this.wuLiaoGuiGeTemp)
        //hcy: 昨天那个问题，已经更新了后台，前端这边也需要做一个修改，
        //就是要删除的物料，传递到后台需要加一个isDeleted=1。
        if (this.wuLiaoGuiGeTemp.id != undefined) {
          this.wuLiaoGuiGeDelList.push(this.wuLiaoGuiGeTemp);
        } else {
          //没有id表示本地临时 增加/删除，这种 不要 传给后台，直接丢弃。
        }
      }
    },

    // 清空为空的XX对象,只有一个 '行' 的这种
    clearNullItem(Items) {
      const formatItems = [];
      Items.forEach((obj) => {
        if (this._.size(obj) <= 1) {
          return;
        }
        for (const key in this.wuLiaoGuiGeKeys) {
          if (this.utils.isEmpty(obj[key])) {
            obj[key] = "";
          }
        }
        formatItems.push(obj);
      });
      return formatItems;
    },

    // 字符串 '2.34512345' 四舍五入成 2位小数=2.35, 再转换成 字符串 '2.35'。注意禁止使用toFixed()。
    // https://wenku.baidu.com/view/a20d74dcadf8941ea76e58fafab069dc50224761.html
    hmjDataChange(inputStr) {
      let data1 = Number(inputStr); // 先转数字
      //Math.round()方法用来把一个数字舍入为最接近的整数
      let data2 = Math.round(data1 * 100) / 100;
      return data2.toString(); //转字符串
    },

    // 根据ID，获取 物料信息
    getWuLiaoInfo(type, wuLiaoId) {
      this.$requestBase({
        url: "v1/material/detail",
        method: "get",
        params: {
          id: wuLiaoId,
        },
      }).then((res) => {
        res = res.data;
        //this.wuLiaoInfo = res
        this.formatResponse(res);
      });
    },

    //格式化 返回结果
    formatResponse(res) {
      //对某些字段 做 显示变换。
      if (res.useBatch === true) {
        res.active = 1; //启用
      } else {
        res.active = 2; //停用
      }
      // console.log('this.res.active=', this.res.active)

      switch (res.kind) {
        case "PB":
          res.kind_change = "胚布";
          break;
        case "YL":
          res.kind_change = "原料";
          break;
        default:
          res.kind_change = "无法识别的类型";
          break;
      }

      switch (res.group) {
        case "PB":
          res.group_change = "胚布";
          break;
        case "YL":
          res.group_change = "原料";
          break;
        default:
          res.group_change = "无法识别的分组";
          break;
      }

      //后台 用integer存储，放大100倍。
      res.stretchRate_change = Number(res.stretchRate / 100).toFixed(2);
      res.dcount_change = Number(res.dcount / 100).toFixed(2);
      res.zcount_change = Number(res.zcount / 100).toFixed(2);

      //boolean 型切换成 中文显示。
      for (let i = 0; i < res.specItems.length; i++) {
        // console.log('i=',i)
        // console.log('isDefault=',this.res.specItems[i].isDefault)

        if (res.specItems[i].isDefault === true) {
          res.specItems[i].isDefault = "是";
        } else {
          res.specItems[i].isDefault = " ";
        }

        //编辑时候，初始化 物料规格 表。
        this.wuLiaoGuiGe.push({
          lineNo: i + 1, //因为i从0开始，这里要比 i多1
          specName: res.specItems[i].specName,
          specNumber: res.specItems[i].specNumber,
          isDefault: res.specItems[i].isDefault,
          // hcy: 后台的判断逻辑：有idh值-》更新既存的规格，无id值-》新建规格
          id: res.specItems[i].id,
        });
      }
      this.wuLiaoGuiGe_index = res.specItems.length; //索引应该=数组长度。

      this.wuLiaoInfo = res;
    },

    //“默认”发生变化时，只能 留下最新的"是"，其它下拉框 都清空" "。
    selectChange(event, lineNo) {
      // console.log("event=", event, "lineNo=",lineNo)
      if (event) {
        //选择"是"
        // console.log("this.wuLiaoGuiGe.length=", this.wuLiaoGuiGe.length)
        for (let i = 0; i < this.wuLiaoGuiGe.length; i++) {
          if (i == lineNo - 1) {
            continue; //跳过自己
          }
          this.$set(this.wuLiaoGuiGe[i], "isDefault", "false");
          // this.$set(this.wuLiaoGuiGe[i], 'isDefault', ' ');
        }
      } else {
        //选择" "
        // console.log("选择空，啥也不做")
      }
      // console.log("this.wuLiaoGuiGe =", this.wuLiaoGuiGe)
    },
  },
  created() {},
  // mounted:html加载完成后执行。执行顺序：子组件-父组件
  mounted() {
    switch (this.$route.query.type) {
      case 1: // 编辑
        this.getWuLiaoInfo(this.$route.query.type, this.$route.query.wuLiaoId);
        break;
      case 0: // 新建
      default:
        break;
    }
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped></style>
